import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HappyMammaService } from '@hm_app/@core/data/happymamma.service';
import { Utente } from '@hm_app/@core/models/utente';
import { MoodleCourseWrapper, MoodleGroup, MoodleService } from '@hm_app/admin/moodle/moodle.service';
import { NbRoleProvider } from '@nebular/security';
import { NbToastrService } from '@nebular/theme';
import { BaseAuthenticatedComponent } from '../base-authenticated/base-authenticated.component';
import _ from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'ngx-lista-corsi-gruppi-utente',
    templateUrl: './lista-corsi-gruppi-utente.component.html',
    styleUrls: ['./lista-corsi-gruppi-utente.component.scss']
})
export class ListaCorsiGruppiUtenteComponent extends BaseAuthenticatedComponent implements OnInit {

    private _utente: Utente;

    public get utente(): Utente {
        return this._utente;
    }

    @Input() public set utente(value: Utente) {
        this._utente = value;
    }
    corsi: MoodleCourseWrapper[];
    gruppi: MoodleGroup[];
    utente_id_url: string;


    @Output() showGroups: EventEmitter<boolean> = new EventEmitter<boolean>();


    constructor(protected moodle_service: MoodleService,
        protected hmService: HappyMammaService,
        protected toastrService: NbToastrService,
        protected roleProvider: NbRoleProvider,
        private spinner: NgxSpinnerService) {
        super(hmService, toastrService, roleProvider);
    }

    async ngOnInit() {
        if (this.isUser) {
            this.utente_id_url = 'me';
        } else {
            this.utente_id_url = String(this.utente.id);
        }

        try {
            this.corsi = await this.moodle_service.getUserCourses(this.utente_id_url).toPromise();
            let all_courses_promises = this.corsi.map(course => this.moodle_service.getUserCourseGroups(this.utente_id_url, course.courseid).toPromise().then(groups => {
                course.groups = _.sortBy(groups, ["idnumber"]).reverse();
                return true;
            }));
            await Promise.all(all_courses_promises);
            this.showGroups.emit(true);
        } catch (error) {
            const msg = 'Errore nel recupero dei dati dei gruppi moodle';
            this.showToast(
                'danger',
                'Errore server',
                msg,
            );
            this.showGroups.emit(false);
        }
        finally {
            this.spinner.hide();
        }




        // this.corsi.forEach(async (course) => {
        //   course.groups = await this.moodle_service.getUserCourseGroups(this.utente_id_url, course.courseid).toPromise();
        //   course.groups = _.sortBy(course.groups, ["idnumber"]).reverse();
        // });
        // this.spinner.hide();
    }

    ngAfterViewInit(): void {
        this.spinner.show();
    }



}
